import { Badge, type BadgeActionProps } from "@spz/ui/components/badge";
import { getIconByExtension } from "../lib/get-icon-by-extension";
// components/attachment-item/attachment-item.tsx
import { cn } from "../lib/utils";
import { TruncatedText } from "./truncated-text";

export interface AttachmentItemProps {
  filename: string;
  onFileClick?: () => void;
  onDeleteClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  canDelete?: boolean;
  className?: string;
  buttonClassName?: string;
  loading?: boolean;
}

export const AttachmentItem = ({
  filename,
  onFileClick,
  onDeleteClick,
  className,
  buttonClassName,
  loading = false,
  canDelete = false,
}: AttachmentItemProps) => {
  const { iconName, textColor } = getIconByExtension(filename);
  return (
    <Badge
      variant="tag"
      icon={iconName}
      iconClassName={textColor}
      className={cn("w-fit justify-between", className)}
      loading={loading}
      action={
        (canDelete && {
          icon: "trash-2",
          onClick: onDeleteClick,
          className: "text-red-500 hover:text-pink-500 ",
        }) as BadgeActionProps
      }
    >
      <TruncatedText
        maxLines={1}
        onClick={onFileClick}
        className={cn(
          "p-0 text-gray-900 font-semibold hover:text-pink-500 flex-1",
          `${onFileClick ? "cursor-pointer" : "cursor-default"}`,
          buttonClassName,
        )}
      >
        {filename}
      </TruncatedText>
    </Badge>
  );
};
